export const UPDATE_FILTERS = 'UPDATE_FILTERS'

export default {
  UPDATE_FILTERS,
}
